// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isEqual(a: any, b: any, depth = 0): boolean {
  // Prevent infinite recursion and limit deep comparisons
  if (depth > 10) return a === b;

  // Fast path: reference equality
  if (a === b) return true;

  // Fast path: type check
  const typeA = typeof a;
  if (typeA !== typeof b) return false;

  // Fast path: null/undefined
  if (a == null || b == null) return a === b;

  // Fast path: primitives
  if (typeA !== 'object') return false;

  // Fast path: same constructor check
  if (a.constructor !== b.constructor) return false;

  // Date objects
  if (a instanceof Date) {
    return a.getTime() === b.getTime();
  }

  // Arrays
  if (Array.isArray(a)) {
    const len = a.length;
    if (len !== b.length) return false;

    for (let i = 0; i < len; i++) {
      if (!isEqual(a[i], b[i], depth + 1)) return false;
    }
    return true;
  }

  // Objects
  const aKeys = Object.keys(a);
  const len = aKeys.length;

  // Fast path: different key counts
  if (len !== Object.keys(b).length) return false;

  // Check each key
  for (let i = 0; i < len; i++) {
    const key = aKeys[i];
    if (!(key in b) || !isEqual(a[key], b[key], depth + 1)) {
      return false;
    }
  }

  return true;
}
